import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { useLogoutConfirm } from '@/composables/useLogoutConfirm'
import { allPermissions } from '@access/index'
import {
CLIENTS_LIST_PAGE_NAME,
LPS_LIST_PAGE_NAME,
TRANSACTIONS_LIST_PAGE_NAME,
SUPPORT_PAGE_NAME,
PROFILE_PAGE_NAME,
FAQ_PAGE_NAME,
NOTIFICATIONS_PAGE_NAME,
REPORTS_LIST_PAGE_NAME
} from '@/components/pages/cabinet/routes'

import {
  logoutResource,
} from '@/services/auth.service'
import { isLp, isAdmin } from '@access/permissions'
import { useNotifications } from '@/stores/notifications'
import { useTransactions } from '@/stores/transactions'
import { useRoute } from 'vue-router'

const CLASS_OPEN = 'is-open'
const SCROLL_LOCKED = 'scroll-locked'

export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: ['UserType', 'isUserbar'],
  setup(__props, { expose: __expose }) {
  __expose();

const jsonString = window.TEXT_PAGES.replace(/&#39;/g, '"');
const jsonArray = JSON.parse(jsonString)

const textPageTitle = computed(() => jsonArray.find( el => el.slug == route.params.slug)?.title)
const { $t } = useGlobal()
const props = __props
const route = useRoute()
const pageTitle = computed(() => route.meta.breadcrumb)
const sidebar = ref(null)
const subscription = ref(null)
const sidebarTrigger = ref(null)
const lsBody = document.querySelector('body')
const store = useNotifications()
const attentionsStore = useTransactions()
const unreadCount = computed(() => store.unreadCount)
const attentionsCount = computed(() => attentionsStore.attentionsCount)

const breadcrumbsLabels = ref({
      'page-not-found': $t('Page is not found'),
      'access-denied': $t('Access is denied'),
      notifications: $t('Notifications'),
      transactions: $t('Transactions'),
      clients: $t('All Clients'),
      lps: $t("All LP's"),
      reports: $t("Reports"),
      profile: $t('Profile'),
      faq: $t('FAQs'),
      support: $t('Support'),
    })

const menuItems = ref([
  {
    title: $t('Transactions'),
    id: 'transactions',
    icon: 'i-side-transactions',
    link: TRANSACTIONS_LIST_PAGE_NAME,
    counter: isAdmin,
    count: isAdmin ? attentionsCount : null
  },
  {
    title: $t('Reports'),
    id: 'reports',
    icon: 'i-side-reports',
    link: REPORTS_LIST_PAGE_NAME,
    // counter: isAdmin,
    // count: isAdmin ? attentionsCount : null
  },
  {
    title: $t('Notifications'),
    id: 'notifications',
    icon: 'i-side-notify',
    link: NOTIFICATIONS_PAGE_NAME,
    counter: true,
    count: unreadCount
  },
  {
    title: $t('All clients'),
    id: 'all-clients',
    icon: 'i-side-clients',
    link: CLIENTS_LIST_PAGE_NAME,
  },
  {
    title: $t('All LPs'),
    id: 'all-lps',
    icon: 'i-side-lps',
    link: LPS_LIST_PAGE_NAME,
  },
  {
    title: $t('Profile'),
    id: 'profile',
    icon: 'i-side-profile',
    link: PROFILE_PAGE_NAME,
  },
  {
    title: $t('FAQs'),
    id: 'faqs',
    icon: 'i-side-faq',
    link: FAQ_PAGE_NAME,
  },
  {
    title: $t('Support'),
    id: 'support',
    icon: 'i-side-support',
    link: SUPPORT_PAGE_NAME,
  },
  {
    title: $t('Log Out'),
    id: 'log-out',
    icon: 'i-side-logout',
    link: '',
  },
])
function closeSidebar() {
  setTimeout(() => {
    subscription.value.forEach(element => {
      element.classList.remove('hidden')
    });
  }, 300);
  sidebar.value.classList.remove(CLASS_OPEN)
  sidebarTrigger.value.classList.remove(CLASS_OPEN)
  lsBody.classList.remove(SCROLL_LOCKED)
}
function toggleSidebar() {
  setTimeout(() => {
    subscription.value.forEach(element => {
      element.classList.toggle('hidden')
    });
  }, 300);
  sidebar.value.classList.toggle(CLASS_OPEN)
  sidebarTrigger.value.classList.toggle(CLASS_OPEN)
  lsBody.classList.toggle(SCROLL_LOCKED)
}

const logout = async () => {
  const question = $t('Are you sure you want to go out?')
  const logout = true
  try {
      await useLogoutConfirm(question)
      const { data: { redirectLink } } = (await logoutResource.execute({}, {}))
      window.location.href = redirectLink
  } catch (e) {
    return Promise.reject(e)
  }
}

const __returned__ = { jsonString, jsonArray, textPageTitle, $t, props, route, pageTitle, sidebar, subscription, sidebarTrigger, lsBody, CLASS_OPEN, SCROLL_LOCKED, store, attentionsStore, unreadCount, attentionsCount, breadcrumbsLabels, menuItems, closeSidebar, toggleSidebar, logout, ref, computed, get useGlobal() { return useGlobal }, get useLogoutConfirm() { return useLogoutConfirm }, get allPermissions() { return allPermissions }, get CLIENTS_LIST_PAGE_NAME() { return CLIENTS_LIST_PAGE_NAME }, get LPS_LIST_PAGE_NAME() { return LPS_LIST_PAGE_NAME }, get TRANSACTIONS_LIST_PAGE_NAME() { return TRANSACTIONS_LIST_PAGE_NAME }, get SUPPORT_PAGE_NAME() { return SUPPORT_PAGE_NAME }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME }, get FAQ_PAGE_NAME() { return FAQ_PAGE_NAME }, get NOTIFICATIONS_PAGE_NAME() { return NOTIFICATIONS_PAGE_NAME }, get REPORTS_LIST_PAGE_NAME() { return REPORTS_LIST_PAGE_NAME }, get logoutResource() { return logoutResource }, get isLp() { return isLp }, get isAdmin() { return isAdmin }, get useNotifications() { return useNotifications }, get useTransactions() { return useTransactions }, get useRoute() { return useRoute } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})